// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top position alignment */
.popover-top {
	bottom: calc(100% + 10px);
	left: 50%;
	transform: translateX(-50%);
}

.align-start-top {
	left: 0;
	transform: translateY(0);
}

.align-middle-top {
	left: 50%;
	transform: translate(-50%, 0);
}

.align-end-top {
	left: 100%;
	transform: translateX(-100%);
}

/* Bottom position alignment */
.popover-bottom {
	top: calc(100% + 10px);
	left: 50%;
	transform: translateX(-50%);
}

.align-start-bottom {
	left: 0;
	transform: translateY(0);
}

.align-middle-bottom {
	left: 50%;
	transform: translate(-50%, 0);
}

.align-end-bottom {
	left: 100%;
	transform: translateX(-100%);
}

/* Left position alignment */
.popover-left {
	right: calc(100% + 10px);
	top: 50%;
	transform: translateY(-50%);
}

.align-start-left {
	top: 0;
	right: calc(100% + 10px);
	transform: translateY(0);
}

.align-middle-left {
	top: 50%;
	right: calc(100% + 10px);
	transform: translateY(-50%);
}

.align-end-left {
	top: 100%;
	right: calc(100% + 10px);
	transform: translateY(-100%);
}

/* Right position alignment */
.popover-right {
	left: calc(100% + 10px);
	top: 50%;
	transform: translateY(-50%);
}

.align-start-right {
	top: 0;
	left: calc(100% + 10px);
	transform: translateY(0);
}

.align-middle-right {
	top: 50%;
	left: calc(100% + 10px);
	transform: translateY(-50%);
}

.align-end-right {
	top: 100%;
	left: calc(100% + 10px);
	transform: translateY(-100%);
}
`, "",{"version":3,"sources":["webpack://./src/@mos-core/components/popover/popover.component.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;CACC,yBAAyB;CACzB,SAAS;CACT,2BAA2B;AAC5B;;AAEA;CACC,OAAO;CACP,wBAAwB;AACzB;;AAEA;CACC,SAAS;CACT,6BAA6B;AAC9B;;AAEA;CACC,UAAU;CACV,4BAA4B;AAC7B;;AAEA,8BAA8B;AAC9B;CACC,sBAAsB;CACtB,SAAS;CACT,2BAA2B;AAC5B;;AAEA;CACC,OAAO;CACP,wBAAwB;AACzB;;AAEA;CACC,SAAS;CACT,6BAA6B;AAC9B;;AAEA;CACC,UAAU;CACV,4BAA4B;AAC7B;;AAEA,4BAA4B;AAC5B;CACC,wBAAwB;CACxB,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,MAAM;CACN,wBAAwB;CACxB,wBAAwB;AACzB;;AAEA;CACC,QAAQ;CACR,wBAAwB;CACxB,2BAA2B;AAC5B;;AAEA;CACC,SAAS;CACT,wBAAwB;CACxB,4BAA4B;AAC7B;;AAEA,6BAA6B;AAC7B;CACC,uBAAuB;CACvB,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,MAAM;CACN,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,QAAQ;CACR,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,SAAS;CACT,uBAAuB;CACvB,4BAA4B;AAC7B","sourcesContent":["/* Top position alignment */\n.popover-top {\n\tbottom: calc(100% + 10px);\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n\n.align-start-top {\n\tleft: 0;\n\ttransform: translateY(0);\n}\n\n.align-middle-top {\n\tleft: 50%;\n\ttransform: translate(-50%, 0);\n}\n\n.align-end-top {\n\tleft: 100%;\n\ttransform: translateX(-100%);\n}\n\n/* Bottom position alignment */\n.popover-bottom {\n\ttop: calc(100% + 10px);\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n\n.align-start-bottom {\n\tleft: 0;\n\ttransform: translateY(0);\n}\n\n.align-middle-bottom {\n\tleft: 50%;\n\ttransform: translate(-50%, 0);\n}\n\n.align-end-bottom {\n\tleft: 100%;\n\ttransform: translateX(-100%);\n}\n\n/* Left position alignment */\n.popover-left {\n\tright: calc(100% + 10px);\n\ttop: 50%;\n\ttransform: translateY(-50%);\n}\n\n.align-start-left {\n\ttop: 0;\n\tright: calc(100% + 10px);\n\ttransform: translateY(0);\n}\n\n.align-middle-left {\n\ttop: 50%;\n\tright: calc(100% + 10px);\n\ttransform: translateY(-50%);\n}\n\n.align-end-left {\n\ttop: 100%;\n\tright: calc(100% + 10px);\n\ttransform: translateY(-100%);\n}\n\n/* Right position alignment */\n.popover-right {\n\tleft: calc(100% + 10px);\n\ttop: 50%;\n\ttransform: translateY(-50%);\n}\n\n.align-start-right {\n\ttop: 0;\n\tleft: calc(100% + 10px);\n\ttransform: translateY(0);\n}\n\n.align-middle-right {\n\ttop: 50%;\n\tleft: calc(100% + 10px);\n\ttransform: translateY(-50%);\n}\n\n.align-end-right {\n\ttop: 100%;\n\tleft: calc(100% + 10px);\n\ttransform: translateY(-100%);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
